<template>
    <ModalFormCard class="modal-default lg:min-w-[800px]" :action="action">
        <template #title>System option</template>

        <template #default="{ saving }">
            <div class="space-y-6">
                <div>
                    <h3 class="text-16 font-semibold">Sign Up</h3>
                    <div class="mt-3 grid grid-cols-2 gap-4">
                        <Input name="name" label="Name" v-model:value="value.name" />
                        <Select
                            name="category"
                            label="Category"
                            :options="categoryOptions"
                            v-model:value="value.category"
                        />
                        <Input name="priority_level" label="Priority" v-model:value="value.priority_level" />
                        <Select
                            name="sub_category"
                            label="Sub Category"
                            :options="subCategoryOptions"
                            v-model:value="value.sub_category"
                        />

                        <InputCheckbox class="" name="use_on_signup" value="1" :checked="value.use_on_signup" @clicked="toggle('use_on_signup')">
                            <p class="pl-2 text-14">Use on sign up</p>
                        </InputCheckbox>
                    </div>
                </div>

                <div class="border-t border-grey-400 pt-6">
                    <h3 class="text-16 font-semibold">Ad Builder</h3>
                    <div class="mt-3 grid grid-cols-2 gap-4">
                        <Input name="ad_name_override" label="Name" v-model:value="value.ad_name_override" />
                        <Input name="priority_ad_builder" label="Priority" v-model:value="value.priority_ad_builder" />
                        <InputCheckbox class="" name="google_automation_best_selling_point" value="1" :checked="value.google_automation_best_selling_point" @clicked="toggle('google_automation_best_selling_point')">
                            <p class="pl-2 text-14">Use In Adwords Builder</p>
                        </InputCheckbox>
                    </div>
                </div>

                <div class="border-t border-grey-400 pt-6">
                    <h3 class="text-16 font-semibold">Lead Category</h3>
                    <div class="mt-3 grid grid-cols-2 gap-4">
                        <Input name="lead_category_name" label="Name" v-model:value="value.lead_category_name" />
                        <Input name="lead_category_priority" label="Priority" v-model:value="value.lead_category_priority" />
                        <InputCheckbox class="" name="lead_category_use_in_ads" value="1" :checked="value.lead_category_use_in_ads" @clicked="toggle('lead_category_use_in_ads')">
                            <p class="pl-2 text-14">Use in lead from</p>
                        </InputCheckbox>
                    </div>
                </div>

                <div class="border-t border-grey-400 pt-6">
                    <h3 class="text-16 font-semibold">Landing Page Builder</h3>
                    <div class="mt-3 grid grid-cols-2 gap-4">
                        <Input name="name_override" label="Name" v-model:value="value.name_override" />
                        <Input name="landing_page_order" label="Priority" v-model:value="value.landing_page_order" />

                        <div v-if="value.image_display" class="col-span-1 border border-grey-400 p-4 flex items-center justify-center bg-white min-h-[120px]">
                            <img :src="`https://my.getwork.co.uk/storage${value.image_display}`" class="max-h-[100px] max-w-full object-contain" />
                        </div>

                        <div v-if="value.image_small_dark" class="col-span-1 border border-grey-400 p-4 flex items-center justify-center bg-black min-h-[120px]">
                            <img :src="`https://my.getwork.co.uk/storage${value.image_small_dark}`" class="max-h-[100px] max-w-full object-contain" />
                        </div>

                        <InputFile name="display_image" label="Image light" />
                        <InputFile name="image_small_dark" label="Image dark" />
                        <Input name="landing_page_title" label="Landing Page Title" v-model:value="value.landing_page_title" class='col-span-2' />
                        <Textarea name="landing_page_text" label="Landing Page desccription" v-model:value="value.landing_page_text" class='col-span-2' />
                    </div>
                </div>

                <div class="border-t border-grey-400 pt-6">
                    <h3 class="text-16 font-semibold">Industries</h3>
                    <div class="mt-3 grid grid-cols-3 gap-4">
                        <InputCheckbox
                            v-for="industry in allIndustries"
                            :key="industry.id"
                            name="industries[]"
                            :value="industry.id"
                            :checked="selectedIndustryIds.includes(industry.id)"
                            @clicked="toggleIndustry(industry.id)"
                        >
                            <p class="pl-2 text-14">{{ industry.name }}</p>
                        </InputCheckbox>
                    </div>
                </div>
            </div>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
                    Save system option
                </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js"
import InputFile from "~/components/customer/input/file.vue"

export default {
    mixins: [Modal],

    data() {
        return {
            value: {
                name: "",
                category: "",
                priority_level: "",
                sub_category: "",
                use_on_signup: false,
                ad_name_override: "",
                priority_ad_builder: "",
                google_automation_best_selling_point: false,
                lead_category_name: "",
                lead_category_priority: "",
                lead_category_use_in_ads: false,
                name_override: "",
                landing_page_order: "",
                image_display: "",
                image_small_dark: "",
                landing_page_title: "",
                landing_page_text: "",
            },
            allIndustries: [],
            selectedIndustryIds: [],
            categoryOptions: [
                { value: "", html: "" },
                { value: "leadCategory", html: "Lead Category" },
                { value: "services", html: "Services" },
                { value: "sellingpoints", html: "Selling Points" },
                { value: "accreditations", html: "Accreditations" },
                { value: "reviews", html: "Reviews" },
                { value: "discounts", html: "Discounts" },
            ],
            subCategoryOptions: [
                { value: "", html: "" },
                { value: "Health & Safety", html: "Health & Safety" },
                { value: "Training & Education", html: "Training & Education" },
                { value: "Products", html: "Products" },
                { value: "Guarantees & Insurance", html: "Guarantees & Insurance" },
                { value: "Suppliers & Merchants", html: "Suppliers & Merchants" },
            ],
        }
    },

    created() {
        this.action = this.editingModel?.id ? `/admin/system-options/${this.editingModel.id}` : "/admin/system-options"
        this.allIndustries = this.options?.industries || []
        this.hydrateValues(this.editingModel)

        if (this.editingModel?.id) {
            this.loadOption()
        }
    },

    methods: {
        async loadOption() {
            const res = await this.$axios.get(`/admin/system-options/${this.editingModel.id}`)
            this.hydrateValues(res.option || res)
        },

        toggle(key) {
            this.value[key] = !this.value[key]
        },

        toggleIndustry(industryId) {
            if (this.selectedIndustryIds.includes(industryId)) {
                this.selectedIndustryIds = this.selectedIndustryIds.filter((id) => id !== industryId)
                return
            }

            this.selectedIndustryIds.push(industryId)
        },

        hydrateValues(source) {
            if (!source) {
                return
            }

            console.log(source)

            this.value.name = source.name
            this.value.category = source.category
            this.value.priority_level = source.priority_level
            this.value.sub_category = source.sub_category
            this.value.use_on_signup = [true, 1, "1"].includes(source.use_on_signup)

            this.value.ad_name_override = source.ad_name_override
            this.value.priority_ad_builder = source.priority_ad_builder
            this.value.google_automation_best_selling_point = [true, 1, "1"].includes(source.google_automation_best_selling_point)

            this.value.lead_category_name = source.lead_category_name
            this.value.lead_category_priority = source.lead_category_priority
            this.value.lead_category_use_in_ads = [true, 1, "1"].includes(source.lead_category_use_in_ads)

            this.value.name_override = source.name_override
            this.value.landing_page_order = source.landing_page_order
            this.value.image_display = source.image_display
            this.value.image_small_dark = source.image_small_dark
            this.value.landing_page_title = source.landing_page_title
            this.value.landing_page_text = source.landing_page_text
            this.selectedIndustryIds = (source.industries || [])
                .map((industry) => industry.industry_id || industry.id)
                .filter(Boolean)
        },
    },

    components: {
        InputFile,
    },
}
</script>
